module.exports = "<div>\r\n  <a class=\"inventory-header__link\"\r\n     ng-click=\"$ctrl.backToSubordinatesList()\"\r\n     target=\"_blank\"\r\n     href=\"\">\r\n    <rw-icon type=\"arrow-left\">\r\n    </rw-icon>\r\n    <translate>\r\n      Back to retailer list\r\n    </translate>\r\n  </a>\r\n\r\n  <translate>\r\n    Viewing data for \r\n  </translate>\r\n\r\n  <rw-retailer-info short-info=\"true\"\r\n                    retailer=\"$ctrl.retailer\">\r\n  </rw-retailer-info>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/modules/manage-inventory/components/inventory-header/inventory-header.html
// module id = 1472
// module chunks = 0